// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard {
  max-width: 1200px;
  margin: 0 auto;
  animation: slideIn 0.3s ease;
}

.leaderboard h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.loading {
  text-align: center;
  font-size: 1.2rem;
  color: #888;
  padding: 2rem;
}

.refresh-button-container {
  text-align: center;
  margin-bottom: 2rem;
}

.refresh-button {
  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);
  border: none;
  color: #0a0a0a;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.refresh-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(0, 255, 136, 0.4);
}

.refresh-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: linear-gradient(135deg, #444 0%, #555 100%);
  color: #999;
}

.tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2rem;
  justify-content: center;
}

.tabs button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.tabs button:hover {
  background: rgba(0, 255, 136, 0.2);
  border-color: rgba(0, 255, 136, 0.4);
}

.tabs button.active {
  background: linear-gradient(135deg, rgba(0, 255, 136, 0.3) 0%, rgba(0, 204, 255, 0.3) 100%);
  border-color: rgba(0, 255, 136, 0.5);
  box-shadow: 0 0 20px rgba(0, 255, 136, 0.3);
}

.leaderboard-content {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2rem;
}

.leaderboard-list h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #00ff88;
  text-align: center;
}

.empty-list {
  text-align: center;
  padding: 2rem;
  color: #888;
}

.leaderboard-item {
  display: grid;
  grid-template-columns: 60px 1fr auto;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  margin-bottom: 0.5rem;
}

.leaderboard-item:hover {
  background: rgba(0, 255, 136, 0.05);
  transform: translateY(-2px);
}

.leaderboard-item:last-child {
  border-bottom: none;
}

.rank {
  font-size: 1.5rem;
  font-weight: bold;
  color: #00ff88;
  text-align: center;
  align-self: center;
}

.person-info {
  align-self: center;
}

.person-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0.25rem;
}

.person-summary {
  font-size: 0.9rem;
  color: #888;
}

.person-value {
  font-size: 1.2rem;
  font-weight: bold;
  align-self: center;
}

.person-value.positive {
  color: #00ff88;
}

.person-value.negative {
  color: #ff4444;
}

.person-details {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 2rem;
}

.details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.details-header h3 {
  font-size: 1.8rem;
  color: #00ff88;
  margin: 0;
}

.close-button {
  background: rgba(255, 68, 68, 0.2);
  border: 1px solid rgba(255, 68, 68, 0.4);
  color: #ff4444;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.close-button:hover {
  background: rgba(255, 68, 68, 0.3);
  border-color: rgba(255, 68, 68, 0.6);
}

.stats-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
}

.stat-value {
  font-size: 2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 0.5rem;
}

.stat-value.positive {
  color: #00ff88;
}

.stat-value.negative {
  color: #ff4444;
}

.stat-label {
  font-size: 0.9rem;
  color: #888;
  text-transform: uppercase;
  font-weight: 500;
}

.drink-stats,
.recent-purchases {
  margin-top: 2rem;
}

.drink-stats h4,
.recent-purchases h4 {
  font-size: 1.3rem;
  color: #00ff88;
  margin-bottom: 1rem;
}

.drink-stats-list {
  display: grid;
  gap: 0.5rem;
}

.drink-stat-item {
  display: grid;
  grid-template-columns: 50px 1fr auto;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  align-items: center;
}

.drink-icon {
  font-size: 1.5rem;
  text-align: center;
}

.drink-info {
  min-width: 0;
}

.drink-name {
  font-weight: 600;
  color: white;
  margin-bottom: 0.25rem;
}

.drink-details {
  font-size: 0.8rem;
  color: #888;
}

.drink-savings {
  font-weight: bold;
  font-size: 1.1rem;
}

.drink-savings.positive {
  color: #00ff88;
}

.drink-savings.negative {
  color: #ff4444;
}

.purchases-list {
  display: grid;
  gap: 0.5rem;
  max-height: 300px;
  overflow-y: auto;
}

.purchase-item {
  display: grid;
  grid-template-columns: 140px 1fr auto;
  gap: 1rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  align-items: center;
  font-size: 0.9rem;
}

.purchase-time {
  color: #888;
  font-size: 0.8rem;
}

.purchase-details {
  color: white;
}

.purchase-total {
  color: #ffaa00;
  font-weight: 500;
  text-align: right;
}

@media (max-width: 768px) {
  .tabs {
    flex-direction: column;
    align-items: stretch;
  }
  
  .tabs button {
    text-align: center;
  }
  
  .leaderboard-item {
    grid-template-columns: 50px 1fr auto;
    gap: 0.75rem;
    padding: 0.75rem;
  }
  
  .rank {
    font-size: 1.2rem;
  }
  
  .person-name {
    font-size: 1rem;
  }
  
  .person-value {
    font-size: 1rem;
  }
  
  .stats-overview {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
  }
  
  .stat-card {
    padding: 1rem;
  }
  
  .stat-value {
    font-size: 1.5rem;
  }
  
  .drink-stat-item {
    grid-template-columns: 40px 1fr auto;
    gap: 0.75rem;
    padding: 0.75rem;
  }
  
  .purchase-item {
    grid-template-columns: 1fr auto;
    gap: 0.5rem;
  }
  
  .purchase-time {
    display: none;
  }
}

@media (max-width: 480px) {
  .details-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .details-header h3 {
    font-size: 1.4rem;
  }
  
  .leaderboard-item {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .rank {
    order: -1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Leaderboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,2FAA2F;EAC3F,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,iGAAiG;EACjG,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,iDAAiD;EACjD,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iGAAiG;EACjG,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2DAA2D;IAC3D,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;IAC/B,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".leaderboard {\n  max-width: 1200px;\n  margin: 0 auto;\n  animation: slideIn 0.3s ease;\n}\n\n.leaderboard h2 {\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.loading {\n  text-align: center;\n  font-size: 1.2rem;\n  color: #888;\n  padding: 2rem;\n}\n\n.refresh-button-container {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.refresh-button {\n  background: linear-gradient(135deg, #00ff88 0%, #00ccff 100%);\n  border: none;\n  color: #0a0a0a;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.refresh-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 20px rgba(0, 255, 136, 0.4);\n}\n\n.refresh-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #444 0%, #555 100%);\n  color: #999;\n}\n\n.tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  justify-content: center;\n}\n\n.tabs button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.tabs button:hover {\n  background: rgba(0, 255, 136, 0.2);\n  border-color: rgba(0, 255, 136, 0.4);\n}\n\n.tabs button.active {\n  background: linear-gradient(135deg, rgba(0, 255, 136, 0.3) 0%, rgba(0, 204, 255, 0.3) 100%);\n  border-color: rgba(0, 255, 136, 0.5);\n  box-shadow: 0 0 20px rgba(0, 255, 136, 0.3);\n}\n\n.leaderboard-content {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 2rem;\n}\n\n.leaderboard-list h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #00ff88;\n  text-align: center;\n}\n\n.empty-list {\n  text-align: center;\n  padding: 2rem;\n  color: #888;\n}\n\n.leaderboard-item {\n  display: grid;\n  grid-template-columns: 60px 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n}\n\n.leaderboard-item:hover {\n  background: rgba(0, 255, 136, 0.05);\n  transform: translateY(-2px);\n}\n\n.leaderboard-item:last-child {\n  border-bottom: none;\n}\n\n.rank {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #00ff88;\n  text-align: center;\n  align-self: center;\n}\n\n.person-info {\n  align-self: center;\n}\n\n.person-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 0.25rem;\n}\n\n.person-summary {\n  font-size: 0.9rem;\n  color: #888;\n}\n\n.person-value {\n  font-size: 1.2rem;\n  font-weight: bold;\n  align-self: center;\n}\n\n.person-value.positive {\n  color: #00ff88;\n}\n\n.person-value.negative {\n  color: #ff4444;\n}\n\n.person-details {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 2rem;\n}\n\n.details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.details-header h3 {\n  font-size: 1.8rem;\n  color: #00ff88;\n  margin: 0;\n}\n\n.close-button {\n  background: rgba(255, 68, 68, 0.2);\n  border: 1px solid rgba(255, 68, 68, 0.4);\n  color: #ff4444;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n}\n\n.close-button:hover {\n  background: rgba(255, 68, 68, 0.3);\n  border-color: rgba(255, 68, 68, 0.6);\n}\n\n.stats-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: bold;\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.stat-value.positive {\n  color: #00ff88;\n}\n\n.stat-value.negative {\n  color: #ff4444;\n}\n\n.stat-label {\n  font-size: 0.9rem;\n  color: #888;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.drink-stats,\n.recent-purchases {\n  margin-top: 2rem;\n}\n\n.drink-stats h4,\n.recent-purchases h4 {\n  font-size: 1.3rem;\n  color: #00ff88;\n  margin-bottom: 1rem;\n}\n\n.drink-stats-list {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.drink-stat-item {\n  display: grid;\n  grid-template-columns: 50px 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  align-items: center;\n}\n\n.drink-icon {\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.drink-info {\n  min-width: 0;\n}\n\n.drink-name {\n  font-weight: 600;\n  color: white;\n  margin-bottom: 0.25rem;\n}\n\n.drink-details {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.drink-savings {\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.drink-savings.positive {\n  color: #00ff88;\n}\n\n.drink-savings.negative {\n  color: #ff4444;\n}\n\n.purchases-list {\n  display: grid;\n  gap: 0.5rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.purchase-item {\n  display: grid;\n  grid-template-columns: 140px 1fr auto;\n  gap: 1rem;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  align-items: center;\n  font-size: 0.9rem;\n}\n\n.purchase-time {\n  color: #888;\n  font-size: 0.8rem;\n}\n\n.purchase-details {\n  color: white;\n}\n\n.purchase-total {\n  color: #ffaa00;\n  font-weight: 500;\n  text-align: right;\n}\n\n@media (max-width: 768px) {\n  .tabs {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .tabs button {\n    text-align: center;\n  }\n  \n  .leaderboard-item {\n    grid-template-columns: 50px 1fr auto;\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n  \n  .rank {\n    font-size: 1.2rem;\n  }\n  \n  .person-name {\n    font-size: 1rem;\n  }\n  \n  .person-value {\n    font-size: 1rem;\n  }\n  \n  .stats-overview {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 0.75rem;\n  }\n  \n  .stat-card {\n    padding: 1rem;\n  }\n  \n  .stat-value {\n    font-size: 1.5rem;\n  }\n  \n  .drink-stat-item {\n    grid-template-columns: 40px 1fr auto;\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n  \n  .purchase-item {\n    grid-template-columns: 1fr auto;\n    gap: 0.5rem;\n  }\n  \n  .purchase-time {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .details-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .details-header h3 {\n    font-size: 1.4rem;\n  }\n  \n  .leaderboard-item {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .rank {\n    order: -1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
